import Axios from "axios";

export const sendInteractionBeforeLogout = async () => {
  try {
    const interactionData = JSON.parse(localStorage.getItem("interactionData"));

    if (!interactionData) return;

    // ✅ Don't call API if interaction count is 0 or undefined
    const interactionCount = Number(interactionData.interactionCount || 0);
    if (interactionCount === 0) return;

    const payload = {
      coworker_interaction: {
        market: interactionData.countryCode,
        interactioncount: interactionCount.toString(),
        interactiondate: interactionData.date,
        browserdetails: navigator.userAgent,
      },
    };

    // Use plain axios (NOT httpClient → avoids interceptor loop)
    await Axios.post(
      `${process.env.REACT_APP_API_URL}/kitchen/coworker/saveinteractioncount`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    // ✅ Reset interaction count after successful API call
    localStorage.setItem(
      "interactionData",
      JSON.stringify({
        ...interactionData,
        interactionCount: 0,
      })
    );
  } catch (err) {
    console.error("Failed to send interaction before logout:", err);
  }
};